import * as icons from 'react-feather';

import { AddColumnIcon } from './add-column-icon';
import { Alert } from './alert';
import { CirclePlusIcon } from './circle-plus-icon';
import { CodeIcon } from './code-icon';
import { CodeInline } from './code-inline';
import { CohortIcon } from './cohort-icon';
import { Combine } from './combine';
import { CustomFormulaIcon } from './custom-formula-icon';
import { Database } from './database';
import { Python } from './python';
import { Detach } from './detach';
import { DownArrowIcon } from './down-arrow-icon';
import { DownArrowOutlinedIcon } from './down-arrow-outlined-icon';
import { Duplicate } from './duplicate';
import { Exploration } from './exploration';
import { FunnelIcon } from './funnel-icon';
import { Graphic } from './graphic';
import { HorizontalEqualsIcon } from './horizontal-equals-icon';
import { Instance } from './instance';
import { LineChartIcon } from './line-chart-icon';
import { LinearIcon } from './linear';
import { SlackIcon } from './slack';
import { GoogleDriveIcon } from './google-drive';
import { NotionIcon } from './notion';
import { ConfluenceIcon } from './confluence';
import { Heading1Icon } from './heading1';
import { Heading2Icon } from './heading2';
import { Heading3Icon } from './heading3';
import { HubSpotIcon } from './hubspot';
import { GitHubIcon } from './github';
import { Model } from './model';
import { Parent } from './parent';
import { Quote } from './quote';
import { RegularTextIcon } from './regular-text';
import { RelatedDataIcon } from './related-data-icon';
import { RightArrowIcon } from './right-arrow-icon';
import { RightArrowOutlinedIcon } from './right-arrow-outlined-icon';
import { SearchIcon } from './search-icon';
import { Block } from './block';
import { SummariseIcon } from './summarise-icon';
import { VariableIcon } from './variable-icon';
import { VariableInstanceIcon } from './variable-instance-icon';
import { VerticalEqualsIcon } from './vertical-equals-icon';
import { DragHandleIcon } from './drag-handle-icon';
import { EventIcon } from './event';
import { TableIcon } from './table-icon';
import { ChevronDownIcon } from './chevron-down-icon';
import { ChevronUpIcon } from './chevron-up-icon';
import { ChevronDownThinIcon } from './chevron-down-thin-icon';
import { SidebarRightIcon } from './sidebar-right-icon';
import { SidebarRightActiveIcon } from './sidebar-right-active-icon';
import { PauseIcon } from './pause-icon';
import { SupersimpleIcon } from './supersimple';
import { AircallIcon } from './aircall';
import { BrushIcon } from './brush';
import { Sort } from './sort';

export type IconName =
  | keyof typeof icons
  | 'AddColumn'
  | 'Alert'
  | 'CirclePlus'
  | 'CodeInline'
  | 'Cohort'
  | 'Combine'
  | 'CustomFormula'
  | 'Database'
  | 'Python'
  | 'Detach'
  | 'DownArrow'
  | 'DownArrowOutlined'
  | 'Duplicate'
  | 'Exploration'
  | 'Funnel'
  | 'Graphic'
  | 'Heading1'
  | 'Heading2'
  | 'Heading3'
  | 'HorizontalEquals'
  | 'Instance'
  | 'LineChart'
  | 'Linear'
  | 'Slack'
  | 'GoogleDrive'
  | 'Notion'
  | 'Confluence'
  | 'HubSpot'
  | 'GitHub'
  | 'Model'
  | 'Parent'
  | 'Quote'
  | 'RegularText'
  | 'RelatedData'
  | 'RightArrow'
  | 'RightArrowOutlined'
  | 'Search'
  | 'Block'
  | 'Summarise'
  | 'Variable'
  | 'VariableInstance'
  | 'VerticalEquals'
  | 'DragHandle'
  | 'Event'
  | 'Table'
  | 'ChevronDownThin'
  | 'SidebarRight'
  | 'SidebarRightActive'
  | 'PauseIcon'
  | 'Aircall'
  | 'Supersimple'
  | 'Brush'
  | 'Sort'
  | 'SortAsc'
  | 'SortDesc';

export type IconProps = {
  name: IconName;
  size?: number;
} & icons.IconProps;

export const Icon = ({ name, ...rest }: IconProps) => {
  switch (name) {
    case 'AddColumn':
      return <AddColumnIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Alert':
      return <Alert size={rest.size} color={rest.color} {...rest} />;
    case 'CirclePlus':
      return <CirclePlusIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Code':
      return <CodeIcon size={rest.size} color={rest.color} {...rest} />;
    case 'CodeInline':
      return <CodeInline size={rest.size} color={rest.color} {...rest} />;
    case 'Cohort':
      return <CohortIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Combine':
      return <Combine size={rest.size} color={rest.color} {...rest} />;
    case 'CustomFormula':
      return <CustomFormulaIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Database':
      return <Database size={rest.size} color={rest.color} {...rest} />;
    case 'Python':
      return <Python size={rest.size} color={rest.color} {...rest} />;
    case 'Detach':
      return <Detach size={rest.size} color={rest.color} {...rest} />;
    case 'DownArrow':
      return <DownArrowIcon size={rest.size} color={rest.color} {...rest} />;
    case 'DownArrowOutlined':
      return <DownArrowOutlinedIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Duplicate':
      return <Duplicate size={rest.size} color={rest.color} {...rest} />;
    case 'Exploration':
      return <Exploration size={rest.size} color={rest.color} {...rest} />;
    case 'Funnel':
      return <FunnelIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Graphic':
      return <Graphic size={rest.size} color={rest.color} {...rest} />;
    case 'Heading1':
      return <Heading1Icon size={rest.size} color={rest.color} {...rest} />;
    case 'Heading2':
      return <Heading2Icon size={rest.size} color={rest.color} {...rest} />;
    case 'Heading3':
      return <Heading3Icon size={rest.size} color={rest.color} {...rest} />;
    case 'HorizontalEquals':
      return <HorizontalEqualsIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Instance':
      return <Instance size={rest.size} color={rest.color} {...rest} />;
    case 'LineChart':
      return <LineChartIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Model':
      return <Model size={rest.size} color={rest.color} {...rest} />;
    case 'Parent':
      return <Parent size={rest.size} color={rest.color} {...rest} />;
    case 'Quote':
      return <Quote size={rest.size} color={rest.color} {...rest} />;
    case 'RegularText':
      return <RegularTextIcon size={rest.size} color={rest.color} {...rest} />;
    case 'RelatedData':
      return <RelatedDataIcon size={rest.size} color={rest.color} {...rest} />;
    case 'RightArrow':
      return <RightArrowIcon size={rest.size} color={rest.color} {...rest} />;
    case 'RightArrowOutlined':
      return <RightArrowOutlinedIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Search':
      return <SearchIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Block':
      return <Block size={rest.size} color={rest.color} {...rest} />;
    case 'Summarise':
      return <SummariseIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Variable':
      return <VariableIcon size={rest.size} color={rest.color} {...rest} />;
    case 'VariableInstance':
      return <VariableInstanceIcon size={rest.size} color={rest.color} {...rest} />;
    case 'VerticalEquals':
      return <VerticalEqualsIcon size={rest.size} color={rest.color} {...rest} />;
    case 'DragHandle':
      return <DragHandleIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Event':
      return <EventIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Table':
      return <TableIcon size={rest.size} color={rest.color} {...rest} />;
    case 'ChevronDown':
      return <ChevronDownIcon size={rest.size} color={rest.color} {...rest} />;
    case 'ChevronUp':
      return <ChevronUpIcon size={rest.size} color={rest.color} {...rest} />;
    case 'ChevronDownThin':
      return <ChevronDownThinIcon size={rest.size} color={rest.color} {...rest} />;
    case 'SidebarRight':
      return <SidebarRightIcon size={rest.size} color={rest.color} {...rest} />;
    case 'SidebarRightActive':
      return <SidebarRightActiveIcon size={rest.size} color={rest.color} {...rest} />;
    case 'PauseIcon':
      return <PauseIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Slack':
      return <SlackIcon size={rest.size} {...rest} />;
    case 'Linear':
      return <LinearIcon size={rest.size} {...rest} />;
    case 'GoogleDrive':
      return <GoogleDriveIcon size={rest.size} {...rest} />;
    case 'Notion':
      return <NotionIcon size={rest.size} {...rest} />;
    case 'GitHub':
      return <GitHubIcon size={rest.size} {...rest} />;
    case 'Confluence':
      return <ConfluenceIcon size={rest.size} {...rest} />;
    case 'HubSpot':
      return <HubSpotIcon size={rest.size} {...rest} />;
    case 'Supersimple':
      return <SupersimpleIcon size={rest.size} />;
    case 'Aircall':
      return <AircallIcon size={rest.size} {...rest} />;
    case 'Brush':
      return <BrushIcon size={rest.size} color={rest.color} {...rest} />;
    case 'Sort':
      return <Sort size={rest.size} color={rest.color} {...rest} />;
    case 'SortAsc':
      return <Sort size={rest.size} color={rest.color} direction="asc" {...rest} />;
    case 'SortDesc':
      return <Sort size={rest.size} color={rest.color} direction="desc" {...rest} />;
    default: {
      const IconComponent = icons[name as keyof typeof icons];
      if (IconComponent === undefined) {
        throw new Error(`Unknown icon: ${name}`);
      }
      return <IconComponent {...rest} />;
    }
  }
};
